const HEX_COLOR_PATTERN = /^#?([0-9a-fA-F]{6})$/;

/** Returns the color as `#RRGGBB` (upper-case) or null when the input is not a 6-digit hex. */
export const normalizeHexColor = (value: string): string | null => {
  const matched = HEX_COLOR_PATTERN.exec(value.trim());
  return matched ? `#${matched[1].toUpperCase()}` : null;
};
